import { useCallback } from 'react'
import { CellTitle, CellValueArea, FormCell, CellPropsBase } from '.'
import { DateTimeRangeV2 } from '../../../../../domain/value-object/DateTimeRangeV2'
import { DateTimeInput } from '../../../../components/inputs/DateTimePicker'
import { RangeDivider, RangeInputWrapper } from './RangeCellLayout'

type DateTimeRangeCellProps = {
  value: DateTimeRangeV2 | undefined
  onChange?: (v: DateTimeRangeV2 | undefined) => void
} & CellPropsBase

export const DateTimeRangeCell = ({
  value,
  onChange,
  cellWidth,
  label,
  help,
  editable = true,
  required,
  edited,
  validationErrors,
}: DateTimeRangeCellProps) => {
  const startDateTime = value?.startDateTime
  const endDateTime = value?.endDateTime
  const handleChangeStartDateTime = useCallback(
    (v: Date | undefined) => {
      onChange &&
        onChange({
          startDateTime: v,
          endDateTime,
        })
    },
    [endDateTime, onChange]
  )
  const handleChangeEndDateTime = useCallback(
    (v: Date | undefined) => {
      onChange &&
        onChange({
          startDateTime,
          endDateTime: v,
        })
    },
    [startDateTime, onChange]
  )
  return (
    <FormCell cellWidth={cellWidth}>
      <CellTitle title={label} required={required} help={help} />
      <CellValueArea edited={edited} validationErros={validationErrors}>
        <RangeInputWrapper>
          <DateTimeInput
            editable={editable}
            value={startDateTime}
            onChange={handleChangeStartDateTime}
            onSelect={handleChangeStartDateTime}
          />
        </RangeInputWrapper>
        <RangeDivider />
        <RangeInputWrapper>
          <DateTimeInput
            editable={editable}
            value={endDateTime}
            onChange={handleChangeEndDateTime}
            onSelect={handleChangeEndDateTime}
          />
        </RangeInputWrapper>
      </CellValueArea>
    </FormCell>
  )
}
